var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.74,
    height: 79,
    viewBox: "0 0 73.74 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 73.74,
    height: 79,
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(-409.761 -6478.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(409.761 6478.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43625",
    "data-name": "Path 43625",
    d: "M42.894,0c.271.233.559.448.812.7q6.823,6.813,13.647,13.625a2.179,2.179,0,0,1,.708,1.7c-.031,2.648-.012,5.3-.012,7.945v.924h.99q4.9,0,9.8,0a4.511,4.511,0,0,1,4.9,4.9q.006,4.127,0,8.254a5.058,5.058,0,0,1-.01.539A1.152,1.152,0,0,1,72.5,39.709a1.1,1.1,0,0,1-1.077-1.17c-.023-1.208-.009-2.417-.009-3.625q0-2.43,0-4.86c0-2.109-.726-2.845-2.812-2.846q-9.565,0-19.13,0c-2.34,0-4.68,0-7.02,0-1.84.005-2.635.8-2.635,2.63q0,18.166,0,36.332c0,1.257-.358,1.814-1.16,1.809S37.5,67.4,37.5,66.155c0-1.2,0-2.406,0-3.7h-.965q-8.408,0-16.816,0a3.191,3.191,0,0,1-.986-.11,1.13,1.13,0,0,1,.224-2.174,6.165,6.165,0,0,1,.847-.025H37.442V52.255h-.91q-8.37,0-16.739,0a4.394,4.394,0,0,1-.844-.046A1.06,1.06,0,0,1,18.008,51a1.039,1.039,0,0,1,1.035-1.042c.255-.024.514-.017.771-.017H37.445V42.055H19.783c-1.255,0-1.8-.362-1.785-1.183.012-.8.526-1.13,1.748-1.13h17.7V31.852H19.931c-1.411,0-1.95-.33-1.933-1.182.016-.816.565-1.148,1.906-1.148H37.429a3.249,3.249,0,0,0,.075-.335A4.47,4.47,0,0,1,42.232,24.9c4.165-.013,8.331,0,12.5,0h.953V16.676h-.857c-2.983,0-5.965,0-8.948,0a4.249,4.249,0,0,1-4.509-4.486c-.011-2.983,0-5.965,0-8.948V2.352c-.306-.014-.555-.036-.8-.036q-18.59,0-37.181,0c-1.043,0-1.045,0-1.045,1.1q0,19.748,0,39.5c0,.257.01.515-.007.771a1.137,1.137,0,0,1-1.107,1.154A1.168,1.168,0,0,1,.033,43.747a6.354,6.354,0,0,1-.015-.771Q.017,23.19,0,3.4A3.148,3.148,0,0,1,2.16,0ZM53.675,14.357,43.688,4.372c0,2.57-.024,5.319.011,8.066a1.857,1.857,0,0,0,1.914,1.91c2.749.024,5.5.008,8.061.008",
    transform: "translate(0)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43626",
    "data-name": "Path 43626",
    d: "M38.086,238.719c-.8-1.762-.468-3.5-.5-5.208a1.1,1.1,0,0,1,1.18-1.149,1.113,1.113,0,0,1,1.114,1.213c.02.9,0,1.8.008,2.7a2.194,2.194,0,0,0,2.427,2.442q13.343.009,26.687,0a2.223,2.223,0,0,0,2.48-2.548q.006-13.69,0-27.381c0-1.105-.007-2.211,0-3.317.007-.874.408-1.35,1.119-1.365.73-.015,1.192.5,1.192,1.389q.007,15.541-.009,31.083a4.411,4.411,0,0,1-4.554,4.45q-33.127.011-66.254,0a2.712,2.712,0,0,1-2.893-2.9q-.012-13.729,0-27.458c0-.962.439-1.473,1.205-1.451.736.021,1.109.5,1.109,1.451q0,13.459,0,26.918c0,1.129,0,1.13,1.091,1.13h34.6Z",
    transform: "translate(-0.063 -162.034)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43627",
    "data-name": "Path 43627",
    d: "M222.805,146.7q4.629,0,9.257,0a2.738,2.738,0,0,1,3.011,3.013q.006,3.009,0,6.017a2.684,2.684,0,0,1-2.861,2.926q-9.489.032-18.978,0a2.684,2.684,0,0,1-2.827-2.892q-.022-3.086,0-6.172a2.723,2.723,0,0,1,2.91-2.889c3.163-.011,6.326,0,9.489,0m-.121,9.633c3.056,0,6.113-.017,9.169.013.707.007.937-.217.918-.932-.046-1.823-.042-3.647,0-5.47.016-.7-.184-.941-.911-.938q-9.131.037-18.262,0c-.678,0-.9.225-.888.892.033,1.823.04,3.648,0,5.47-.018.736.214.986.962.977,3-.034,6.01-.014,9.015-.014",
    transform: "translate(-167.027 -116.462)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43628",
    "data-name": "Path 43628",
    d: "M301.6,281.922c0,1.8.008,3.6,0,5.394a2.8,2.8,0,0,1-2.931,2.973c-.59.015-1.183.028-1.771-.012a2.745,2.745,0,0,1-2.674-2.755q-.05-5.663,0-11.326a2.7,2.7,0,0,1,2.546-2.709,11.77,11.77,0,0,1,2.306,0A2.73,2.73,0,0,1,301.6,276.3c.018,1.875,0,3.75,0,5.625m-2.316-.013c0-1.466.006-2.931,0-4.4-.01-1.809.272-1.755-1.74-1.743-.931.006-1.015.087-1.015,1.013q0,4.705,0,9.41c0,1.909-.222,1.775,1.867,1.793.656.005.915-.232.9-.908-.034-1.722-.011-3.445-.011-5.168",
    transform: "translate(-233.556 -217.069)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43629",
    "data-name": "Path 43629",
    d: "M99.609,96.083q-5.239,0-10.477,0a5.715,5.715,0,0,1-.845-.034,1.133,1.133,0,0,1-.143-2.2,2.78,2.78,0,0,1,.76-.086q10.709-.006,21.417,0a2.765,2.765,0,0,1,.834.1.94.94,0,0,1,.735,1.175,2.294,2.294,0,0,1-.9.991c-.193.137-.548.056-.83.056q-5.277,0-10.554,0",
    transform: "translate(-69.334 -74.43)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43630",
    "data-name": "Path 43630",
    d: "M259.7,323.091c0,.308,0,.615,0,.923a2.588,2.588,0,0,1-2.725,2.771c-.666.016-1.334.021-2,0a2.592,2.592,0,0,1-2.664-2.685c-.016-.692-.021-1.385,0-2.077a2.559,2.559,0,0,1,2.577-2.6c.692-.025,1.385-.021,2.077-.007a2.571,2.571,0,0,1,2.732,2.752c0,.308,0,.615,0,.923m-2.321,1.37c0-.849.023-1.59-.02-2.327-.008-.139-.266-.356-.43-.38-2.151-.3-2.4-.066-2.3,2.081,0,.077-.028.178.01.227.112.144.245.375.379.382.761.037,1.524.018,2.364.018",
    transform: "translate(-200.288 -253.566)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43631",
    "data-name": "Path 43631",
    d: "M217.758,231.273c.234,2.7-.984,3.934-3.717,3.705-.357-.03-.718,0-1.077-.006a2.586,2.586,0,0,1-2.588-2.524c-.038-.768-.035-1.54,0-2.308a2.591,2.591,0,0,1,2.568-2.551c.666-.029,1.334-.015,2-.007a2.619,2.619,0,0,1,2.814,2.845c0,.282,0,.564,0,.846m-2.317.037c-.022-1.6.222-1.391-1.442-1.408a3.559,3.559,0,0,1-.46,0c-.677-.1-.953.189-.859.862a3.521,3.521,0,0,1,0,.46c.014,1.664-.168,1.434,1.416,1.436,1.527,0,1.324.193,1.342-1.345",
    transform: "translate(-166.99 -180.662)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43632",
    "data-name": "Path 43632",
    d: "M214.031,280.818c-.333,0-.667.006-1,0a2.572,2.572,0,0,1-2.641-2.616c-.022-.717-.025-1.437,0-2.153a2.525,2.525,0,0,1,2.369-2.565,15.122,15.122,0,0,1,2.762.018,2.485,2.485,0,0,1,2.248,2.5c.02.692.012,1.385,0,2.077a2.566,2.566,0,0,1-2.744,2.736c-.333,0-.667,0-1,0m1.425-5.051c-.768,0-1.455.014-2.14,0-.47-.013-.631.191-.618.648.074,2.554-.441,2.027,2.086,2.092.1,0,.234.034.3-.016.141-.105.347-.251.354-.388.035-.737.016-1.477.016-2.332",
    transform: "translate(-167.008 -217.066)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43633",
    "data-name": "Path 43633",
    d: "M214.094,319.337c2.726-.225,3.923.967,3.7,3.713-.031.382.006.769-.011,1.153a2.479,2.479,0,0,1-2.217,2.452,16.144,16.144,0,0,1-2.915,0,2.494,2.494,0,0,1-2.246-2.512c-.028-.64-.011-1.282-.007-1.923a2.615,2.615,0,0,1,2.846-2.884c.282,0,.564,0,.846,0m1.382,3.684c-.025-1.535.225-1.341-1.337-1.359h-.077c-1.518.016-1.341-.182-1.34,1.366,0,1.468-.218,1.374,1.347,1.371,1.676,0,1.377.124,1.407-1.377",
    transform: "translate(-167.024 -253.491)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43634",
    "data-name": "Path 43634",
    d: "M256.019,234.964c-.308,0-.616,0-.923,0a2.611,2.611,0,0,1-2.781-2.724c-.013-.667-.017-1.334,0-2a2.607,2.607,0,0,1,2.617-2.662c.717-.025,1.437-.025,2.154,0a2.588,2.588,0,0,1,2.614,2.654c.013.667.009,1.334,0,2a2.588,2.588,0,0,1-2.76,2.733c-.308,0-.616,0-.923,0m0-2.314c1.546-.019,1.37.2,1.366-1.321,0-1.62.237-1.428-1.41-1.434-1.5-.005-1.343-.147-1.341,1.363,0,1.6-.159,1.373,1.385,1.392",
    transform: "translate(-200.296 -180.652)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43635",
    "data-name": "Path 43635",
    d: "M301.581,231.265c0,.359.009.719,0,1.077a2.576,2.576,0,0,1-2.6,2.586c-.718.016-1.437.014-2.154,0a2.585,2.585,0,0,1-2.632-2.557c-.031-.768-.035-1.54,0-2.308a2.571,2.571,0,0,1,2.447-2.508,20.553,20.553,0,0,1,2.461,0,2.569,2.569,0,0,1,2.469,2.557c.013.384,0,.769,0,1.154m-3.767,1.352c1.684-.025,1.427.233,1.452-1.47a4.893,4.893,0,0,1,0-.536c.069-.557-.137-.779-.725-.76-2.454.079-1.972-.413-2.044,2.061-.015.523.151.773.7.71a5.287,5.287,0,0,1,.613,0",
    transform: "translate(-233.536 -180.62)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43636",
    "data-name": "Path 43636",
    d: "M255.912,280.831c-2.969.249-3.895-1.257-3.692-3.73.029-.357-.008-.718.009-1.077a2.519,2.519,0,0,1,2.329-2.522,15.072,15.072,0,0,1,2.838.018,2.471,2.471,0,0,1,2.212,2.456c.025.717.015,1.436.006,2.154a2.561,2.561,0,0,1-2.7,2.7c-.333.005-.667,0-1,0m1.384-5.051c-.769,0-1.455.014-2.141,0-.47-.013-.631.191-.618.648.074,2.554-.442,2.027,2.086,2.092.1,0,.234.034.3-.016.141-.105.348-.251.354-.388.035-.737.017-1.476.017-2.332",
    transform: "translate(-200.209 -217.079)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43637",
    "data-name": "Path 43637",
    d: "M43.031,291.73c.744,0,1.489-.016,2.232.006a1.148,1.148,0,0,1,1.213,1.125,1.162,1.162,0,0,1-1.189,1.166q-2.27.049-4.542,0a1.116,1.116,0,0,1-1.191-1.22c.032-.662.47-1.056,1.244-1.074.744-.018,1.488,0,2.233,0",
    transform: "translate(-31.4 -231.591)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43638",
    "data-name": "Path 43638",
    d: "M42.982,96.043c-.744,0-1.489.022-2.232-.006a1.1,1.1,0,0,1-1.192-1.129,1.106,1.106,0,0,1,1.167-1.167c1.513-.038,3.028-.035,4.542,0a1.169,1.169,0,0,1,1.214,1.145,1.185,1.185,0,0,1-1.265,1.161c-.051,0-.1,0-.154,0H42.982v0",
    transform: "translate(-31.404 -74.396)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43639",
    "data-name": "Path 43639",
    d: "M42.986,145.517c-.744,0-1.489.025-2.232-.007a1.148,1.148,0,1,1-.032-2.295c1.513-.039,3.028-.036,4.541,0a1.163,1.163,0,0,1,1.217,1.139,1.191,1.191,0,0,1-1.262,1.168c-.051,0-.1,0-.154,0H42.986v-.006",
    transform: "translate(-31.404 -113.672)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43640",
    "data-name": "Path 43640",
    d: "M43.034,242.267c.744,0,1.489-.019,2.232,0a1.15,1.15,0,0,1,1.206,1.131,1.133,1.133,0,0,1-1.118,1.149q-2.346.059-4.694,0a1.14,1.14,0,1,1,.065-2.278c.769-.026,1.539-.006,2.309-.006",
    transform: "translate(-31.397 -192.323)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43641",
    "data-name": "Path 43641",
    d: "M42.988,195.082c-.718,0-1.437.022-2.155,0-.819-.03-1.265-.449-1.276-1.137-.011-.728.444-1.153,1.316-1.163q2.154-.025,4.31,0a1.155,1.155,0,1,1,.036,2.3c-.743.029-1.488.006-2.232.007",
    transform: "translate(-31.403 -153.031)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43642",
    "data-name": "Path 43642",
    d: "M221.9,31.2c-2.562,0-5.312.016-8.061-.008a1.857,1.857,0,0,1-1.914-1.91c-.035-2.748-.011-5.5-.011-8.066L221.9,31.2",
    transform: "translate(-168.228 -16.839)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43643",
    "data-name": "Path 43643",
    d: "M231.581,165.227c-3.005,0-6.011-.02-9.015.014-.748.009-.98-.241-.962-.977.043-1.823.036-3.647,0-5.47-.012-.667.21-.895.888-.892q9.131.031,18.262,0c.727,0,.927.241.911.938-.04,1.823-.044,3.648,0,5.47.018.715-.212.939-.919.932-3.056-.029-6.113-.012-9.169-.012",
    transform: "translate(-175.924 -125.351)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.355
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43652",
    "data-name": "Path 43652",
    d: "M231.581,165.227c-3.005,0-6.011-.02-9.015.014-.748.009-.98-.241-.962-.977.043-1.823.036-3.647,0-5.47-.012-.667.21-.895.888-.892q9.131.031,18.262,0c.727,0,.927.241.911.938-.04,1.823-.044,3.648,0,5.47.018.715-.212.939-.919.932-3.056-.029-6.113-.012-9.169-.012",
    transform: "translate(-213.449 -150.879)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.355
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43644",
    "data-name": "Path 43644",
    d: "M308.235,290.9c0,1.723-.023,3.446.011,5.168.013.677-.246.914-.9.908-2.089-.017-1.865.116-1.867-1.793q0-4.7,0-9.41c0-.926.084-1.007,1.015-1.013,2.012-.013,1.73-.066,1.74,1.743.008,1.465,0,2.931,0,4.4",
    transform: "translate(-242.505 -226.062)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.351
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43645",
    "data-name": "Path 43645",
    d: "M266.27,333.1c-.84,0-1.6.019-2.364-.018-.134-.007-.267-.238-.379-.382-.038-.049-.007-.15-.01-.227-.1-2.147.152-2.384,2.3-2.081.165.023.422.241.43.38.043.737.02,1.478.02,2.327",
    transform: "translate(-209.184 -262.201)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.351
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43646",
    "data-name": "Path 43646",
    d: "M224.352,240.2c-.017,1.539.185,1.347-1.342,1.345-1.584,0-1.4.229-1.416-1.436a3.521,3.521,0,0,0,0-.46c-.094-.672.182-.958.859-.862a3.559,3.559,0,0,0,.46,0c1.664.017,1.42-.189,1.442,1.408",
    transform: "translate(-175.9 -189.555)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.351
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43647",
    "data-name": "Path 43647",
    d: "M224.408,284.756c0,.855.018,1.594-.016,2.332-.006.137-.213.283-.354.388-.068.05-.2.019-.3.016-2.527-.065-2.013.462-2.086-2.092-.013-.457.147-.661.618-.648.686.019,1.372,0,2.14,0",
    transform: "translate(-175.961 -226.055)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.271
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43648",
    "data-name": "Path 43648",
    d: "M224.409,332.075c-.03,1.5.269,1.373-1.407,1.377-1.565,0-1.346.1-1.347-1.371,0-1.547-.178-1.35,1.34-1.366h.077c1.562.019,1.312-.176,1.337,1.359",
    transform: "translate(-175.958 -262.544)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.351
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43649",
    "data-name": "Path 43649",
    d: "M264.96,241.623c-1.543-.019-1.383.21-1.385-1.392,0-1.511-.163-1.368,1.341-1.363,1.646.006,1.405-.186,1.41,1.434,0,1.521.18,1.3-1.366,1.321",
    transform: "translate(-209.241 -189.626)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.271
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43650",
    "data-name": "Path 43650",
    d: "M306.774,241.6a5.38,5.38,0,0,0-.613,0c-.548.063-.714-.186-.7-.71.072-2.474-.41-1.982,2.044-2.061.587-.019.793.2.725.76a4.913,4.913,0,0,0,0,.537c-.025,1.7.232,1.445-1.452,1.47",
    transform: "translate(-242.496 -189.599)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.271
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43651",
    "data-name": "Path 43651",
    d: "M266.318,284.755c0,.855.018,1.595-.017,2.332-.006.137-.213.283-.354.388-.068.05-.2.019-.3.016-2.528-.065-2.012.462-2.086-2.092-.013-.458.147-.661.618-.648.686.019,1.372,0,2.141,0",
    transform: "translate(-209.232 -226.055)",
    fill: "#55cece",
    stroke: "#55cece",
    strokeWidth: 1,
    opacity: 0.271
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic4);
export default __webpack_public_path__ + "static/media/topic4.e5f098477ec375ec9aae02e83625b34c.svg";
export { ForwardRef as ReactComponent };